(function(){
  if (window.__duloraHomeInit) return; window.__duloraHomeInit = true;
  var run = function(){
    var els = document.querySelectorAll('.fi');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('vis');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('vis'); io.unobserve(en.target); } });
    }, { threshold: 0.08 });
    els.forEach(function(e){ io.observe(e); });
  };
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
